
define('text!sharingTemplate/shareBtn.mustache',[],function () { return '<div class="share-btn"> \n   <div class="openSocial"></div>\n   <div class="closeSocial"></div>\n</div>  ';});

